import Cookies from 'js-cookie';

const COOKIE_KEY = 'userGeoLocation';

export const getGeoIPFromCache = () => Cookies.get(COOKIE_KEY);
export const saveGeoIPToCache = (city, country, ip) => Cookies.set(COOKIE_KEY, JSON.stringify({ city, country, ip }), { expires: 30, secure: true });
